<template>
    <div>
        <CompassTooltip
            :content="$t.__(getExtensionOption(option).label)"
            placement="top"
            :delay="{ show: 0, hide: 1 }"
            :disabled="disabled"
        >
            <CompassIconButton
                :icon="getExtensionOption(option).icon"
                size="small"
                :disabled="disabled"
                ref="customTagsRichTextTrigger"
                @click="showMenu"
            />
        </CompassTooltip>
        <CompassPopover
            :title="$t.__(getExtensionOption(option).label)"
            :isVisible="showMenuCustomTags"
            custom-class="custom-popover-customtags"
            no-close-on-click-outside=".customtags-select"
            triggerRef="customTagsRichTextTrigger"
            @close="hideMenu"
        >
            <div class="flex-row">
                <CompassSelect
                    v-if="!loading"
                    v-model="selectedTag"
                    :placeholder="$t.__('richtext.customoptions.CustomTagsRichText.search_tag')"
                    menu-class="customtags-select"
                >
                    <CompassOptionGroup
                        v-for="group in tags"
                        :key="group.label"
                        :label="$t.__(group.label)"
                    >
                        <CompassDropdownSelectOption
                            v-for="option in group.options"
                            :key="option.value"
                            :label="$t.__(option.label)"
                            :value="option.value"
                        />
                    </CompassOptionGroup>
                </CompassSelect>
                <CompassButton
                    :label="$t.__('common.actions.add')"
                    type="primary"
                    :disabled="!selectedTag"
                    class="ml-2"
                    @click="addTag"
                />
            </div>
        </CompassPopover>
    </div>
</template>

<script>
import OptionsRichTextMixin from 'mixins/OptionsRichTextMixin';

export default {
    name: 'CustomTagsRichText',
    mixins: [OptionsRichTextMixin],
    data() {
        return {
            showMenuCustomTags: false,
            selectedTag: '',
            tags: [],
            loading: true,
        };
    },
    created() {
        this.getTags()
            .then((result) => (this.tags = this.generateCompassOptions(result)))
            .finally(() => (this.loading = false));
    },
    methods: {
        showMenu() {
            this.showMenuCustomTags = true;
        },
        hideMenu() {
            this.showMenuCustomTags = false;
            this.$emit('close');
        },
        addTag() {
            this.editor.commands.setImage({
                src: `/ressources/logged/img/tags/fr/${this.selectedTag}.png`,
            });
            this.hideMenu();
        },
        getTags() {
            return new Promise((resolve, reject) => {
                this.$ajax.get(
                    this.$router.resolve({
                        name: 'legacy.settings.customtag',
                        params: { context: 'emailTemplate' },
                    }).href,
                    {},
                    (response) => {
                        resolve(response);
                    },
                    () => {
                        reject();
                    },
                );
            });
        },
        generateCompassOptions(data) {
            let compassOptions = [];
            let currentGroup = null;

            for (const item of data) {
                if (item.name === 'null') {
                    currentGroup = { label: item.label.replace(/-/g, ''), options: [] };
                    compassOptions.push(currentGroup);
                } else if (currentGroup) {
                    currentGroup.options.push({ label: item.label, value: item.name });
                }
            }

            // filter out 'Opportunité' and 'Société' tags (not needed in DocPageFooterPref)
            compassOptions = compassOptions.filter((item) => {
                const label = item.label.toUpperCase();
                return label !== 'OPPORTUNITÉ' && label !== 'SOCIÉTÉ';
            });

            return compassOptions;
        },
    },
};
</script>

<style lang="scss">
.customtags-select {
    z-index: 1001 !important;
}
</style>
